<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/180605-feature-dr-lam-tak-sum.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">追查遺傳基因 罕見疾病難隱身</div>
                   <div class="post_info">Posted at 09:00h in 遺傳病</div>
            
                    <div class="post_wrapper_1">
                      脊髓性肌肉萎縮症、小腦萎縮症、唐氏綜合症等遺傳病可經由基因一代傳一代，而遺傳學專家就如偵探一樣，可利用基因檢測等技術，在婚前檢查或產前檢查階段，盡力發掘潛藏的遺傳密碼，以減低病發率及相關併發症出現，尤其是一些罕見但可帶來嚴重危害的遺傳疾病。
                    </div>

                    <div class="post_wrapper_1">
                      養和醫院醫學遺傳科主任林德深醫生指出，現時已知的罕見遺傳病大約有六千多種，當中約一千多種屬於隱性，如脊髓性肌肉萎縮症（SMA）、地中海貧血症等，其中地貧便有多達一成人帶有隱性遺傳基因，並有四分一機會傳給下一代。由於這些病症可帶來嚴重健康及生活危害，故「好值得做篩選」以及早偵察和處理。
                    </div>

                    <div class="post_wrapper_1">
                      他稱，若發現帶有變異基因，在不同階段可以有不同的處理，例如在計劃生育階段，可以透過試管嬰兒的技術，揀選不帶疾病基因的胚胎作懷孕，從而避開可能出現的嚴重遺傳病。假如在產前檢查診斷出胎兒可能有嚴重問題，例如唐氏綜合症，則可考慮是否終止懷孕。至於一些能夠治療及處理的遺傳病，如蠶豆症（G6PD缺乏症），及早知道能讓新生嬰兒得到更好的照料。
                    </div>
                    <div class="post_wrapper_1">
                      你或許會以為，與生俱來的疾病與遺傳有關，但林醫生強調，其實大部分後天疾病，如癌症、心血管病及糖尿病等等，均可與遺傳基因扯上關係，特別是家族中出現異常的發病或多宗病例，更要懷疑可能是遺傳基因的影響。
                    </div>
                    <div class="post_wrapper_1">
                      他續說，本港常見的大腸癌及乳腺癌，出現遺傳情況並不少見，及早發現有相關的問題基因，便可以採取預防性措施，例如更早及更頻密進行篩查，又或施行預防性治療，阻截病變發生。
                    </div>
                    <div class="post_wrapper_1">
                      隨著基因科技進步，檢測速度加快，費用亦由過往的天價到現在很多人也能負擔。但篩選過程中，醫生需要衡量多種因素。
                    </div>
                    <div class="post_wrapper_1">
                      林醫生解釋，基因檢測的結果難料，可引起很多疑惑和擔心，將對日後生活及生育都是嚴峻的考慮，亦要考慮驗測結果是否有方法可以預防或治療，「如果無得醫或無得預防，驗唔驗、生唔生仔呢，有無其他選擇呢」，因此檢測前後要有適當的輔導，幫助病人面對。
                    </div>
                    
                    <div class="post_wrapper_1">
                        參考資料：<a href="https://health.mingpao.com/%E8%BF%BD%E6%9F%A5%E9%81%BA%E5%82%B3%E5%9F%BA%E5%9B%A0-%E7%BD%95%E8%A6%8B%E7%96%BE%E7%97%85%E9%9B%A3%E9%9A%B1%E8%BA%AB/">
                       明報健康網 </a>
                    </div>
                    
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    ul{
                            list-style-position: inside;
                            display: block;
                            list-style-type: disc;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px;
                            padding-inline-start: 40px;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/genstwelve.vue